import {Directive, Input, HostListener} from '@angular/core';
import {YandexMetricService} from '@app/core/services/yandex-metric.service';

@Directive({
  selector: '[ymGoal]',
})
export class YandexMetrikaGoalDirective {
  @Input() trackOn: string;

  constructor(private readonly ym: YandexMetricService) {}

  @HostListener('click') click() {
    this.ym.reachGoal.next(this.trackOn);
  }
}
